import { connect } from 'react-redux';
import { RootState } from 'redux/store';
import { getCustomerAuthError } from 'redux/customer/customer.selectors';
import Badge from './Badge.page';

const mapStateToProps = (
  state: RootState,
): {
  error: string | null;
} => ({
  error: getCustomerAuthError(state),
});

export default connect(mapStateToProps)(Badge);
